import React, { useState } from 'react';
import { ControlService, CssPropertyType } from '../../types';
import {
  MIN_PERCENTAGE_VALUE,
  MAX_PERCENTAGE_VALUE,
  MIN_RANGE_VALUE,
  MAX_RANGE_VALUE,
  PERCENTAGE_START_POINT,
  setSpacingValueShape,
} from '../constants';
import { usePropotionalControl } from '../hooks/usePropotionalControl';
import { useControlService } from '../../common/atomic/hooks';
import { getValidStyleIds } from '../../common/valueResolverService';

type Mode = 'percentage' | 'range';
class SpacingControlBehavior {
  private mode: Mode;

  constructor({ mode }: { mode: Mode }) {
    this.mode = mode;
  }

  getMinValue() {
    return this.mode === 'percentage' ? MIN_PERCENTAGE_VALUE : MIN_RANGE_VALUE;
  }

  getMaxValue(controlValue: number) {
    return this.mode === 'percentage'
      ? MAX_PERCENTAGE_VALUE
      : controlValue < MAX_RANGE_VALUE
      ? MAX_RANGE_VALUE
      : controlValue;
  }

  getStartPoint() {
    return this.mode === 'percentage' ? PERCENTAGE_START_POINT : undefined;
  }
}

type SpacingControlProps = {
  cssPropertyTypes: CssPropertyType[];
  label: string;
};

export const SpacingControl: React.FC<SpacingControlProps> = ({
  cssPropertyTypes,
  label,
}) => {
  const service = useControlService();
  const validStyleIds = getValidStyleIds(
    service.styles,
    service.styleDefinitions,
    cssPropertyTypes,
  );
  const { getControl, controlValue, updateControl, percentageMode } =
    usePropotionalControl({
      service,
      styleIds: validStyleIds,
    });

  const [Control] = useState(
    () => getControl('length', 'cssVariableType').Component,
  );

  if (validStyleIds.length === 0) {
    return null;
  }

  const behavior = new SpacingControlBehavior({
    mode: percentageMode ? 'percentage' : 'range',
  });

  return (
    <Control
      minValue={behavior.getMinValue()}
      maxValue={behavior.getMaxValue(controlValue)}
      startPoint={behavior.getStartPoint()}
      label={label}
      value={setSpacingValueShape(controlValue)}
      onChange={(value) => {
        // @ts-expect-error - TODO: ds-types-bump
        updateControl(value?.value ?? 0);
      }}
    />
  );
};
